/**
 * A "render" is one infinite-scroll load of new Explore content. The initial
 * page load is not a render. Guests get this many renders, then the next load
 * attempt opens the register modal instead of fetching. While auth is still
 * loading, a load past the limit waits instead of gating, so a signed-in user
 * with a slow session is never shown the modal.
 */
export const FREE_EXPLORE_RENDERS = 4

export type ExploreLoadDecision = "fetch" | "gate" | "wait"

export function countExploreRenders(loadedPageCount: number): number {
  return Math.max(0, loadedPageCount - 1)
}

export function decideExploreLoad({
  isAuthenticated,
  isAuthLoading,
  loadedPageCount,
}: {
  isAuthenticated: boolean
  isAuthLoading: boolean
  loadedPageCount: number
}): ExploreLoadDecision {
  if (isAuthenticated) return "fetch"
  if (countExploreRenders(loadedPageCount) < FREE_EXPLORE_RENDERS) return "fetch"
  return isAuthLoading ? "wait" : "gate"
}
